import Helpers from "./helpers";
import SelectorFilter from "./selector-filter";

export default class ToggleBlock {

	private toggleBlockElements = SelectorFilter.excludeByClass(document.querySelectorAll('.js-toggle-block'), 'js-toggle-block-done');
	private collapsedCssClassName = 'collapsed';

	constructor() {

		if (!this.toggleBlockElements.length) return;

		const self = this;

		Helpers.scopedLoop(this.toggleBlockElements, function (toggleBlockElement: HTMLElement, i: Number, context: any) {

			self.setupToggleBlock(toggleBlockElement);

		}, this);

	}

	private setupToggleBlock(toggleBlockElement: HTMLElement) {

		const titleElement = toggleBlockElement.querySelector('.js-toggle-title');
		const toggleContentElement = toggleBlockElement.querySelector('.js-toggle-content');
		const stateInputElement = toggleBlockElement.querySelector('.js-toggle-expanded') as HTMLInputElement;
		const toggleValue = toggleContentElement.getAttribute('data-toggle-value');

		if (stateInputElement.value !== toggleValue) {
			toggleContentElement.classList.add(this.collapsedCssClassName);
			titleElement.classList.add(this.collapsedCssClassName);
		}

		titleElement.addEventListener('click', (e: Event) => {

			const targetElement = e.target as HTMLElement;

			if (targetElement.closest('.js-tooltip-trigger')) {
				return;
			}

			Helpers.deferTask(() => {	
				toggleContentElement.classList.toggle(this.collapsedCssClassName);
				titleElement.classList.toggle(this.collapsedCssClassName);
				const isExpanded = !titleElement.classList.contains(this.collapsedCssClassName);
				titleElement.setAttribute('aria-expanded', isExpanded ? "true" : "false");
				stateInputElement.value = isExpanded ? toggleValue : '';
			});

			e.preventDefault();

		});

		toggleBlockElement.classList.add('js-toggle-block-done');
		
	}


}
